// components/DaimonChatsReport.tsx
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import SimpleLoader from './ui/SimpleLoader';

type Message = { id: string; at: string; role: 'user' | 'assistant' | 'tool'; text: string };

const when = (iso: string) => new Date(iso).toLocaleString(undefined, { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });

/** A Daimon conversation's full transcript, opened under its row of the activity feed. Fater admins only. */
const DaimonTranscript = React.memo(function DaimonTranscript({ sessionId, userName }: { sessionId: string; userName: string }) {
  const [messages, setMessages] = useState<Message[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    axios.post<{ messages: Message[] }>('/api/admin', { action: 'getDaimonChats', sessionId })
      .then((response) => { if (alive) setMessages(response.data.messages); })
      .catch((err) => { if (alive) setError(err.response?.status === 403 ? 'Only Fater admins can read Daimon conversations.' : 'This conversation could not be loaded.'); });
    return () => { alive = false; };
  }, [sessionId]);

  return (
    <div className="border-b border-white/[0.06] px-6 py-4 text-white/75" style={{ fontSize: 13 }}>
      {error ? <p className="text-white/40">{error}</p> : !messages ? <SimpleLoader message="Loading transcript..." /> : messages.length === 0 ? <p className="text-white/40">No messages.</p> : (
        <ol className="flex max-w-3xl flex-col gap-3">
          {messages.map((message) => message.role === 'tool' ? (
            // Her action and what it returned, beside her words.
            <li key={message.id} className="whitespace-pre-wrap border-l border-white/10 pl-3 font-mono text-white/40" style={{ fontSize: 11 }}>{message.text}</li>
          ) : (
            <li key={message.id} className={message.role === 'user' ? 'self-end rounded-2xl bg-white/[0.08] px-3 py-2 text-white' : 'text-white/80'}>
              <div className="text-white/35" style={{ fontSize: 11 }}>{message.role === 'user' ? userName : 'Daimon'} · {when(message.at)}</div>
              <div className="whitespace-pre-wrap">{message.text}</div>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
});

export default DaimonTranscript;
